module.exports = __webpack_public_path__ + "static/img/son3_active.8dc7e657.png";